import { Select, MenuItem } from '@/components'
import { DataGridSelectCellProps } from '../types'
import { useEffect, useState } from 'react'

function DataGridSelectCell ( props: DataGridSelectCellProps ) {
    const {
        data, field, width, selectProps, rowData, idx,
        setRowData,
    } = props
    const { dataSource, onChange } = selectProps
    const [ input, setInput ] = useState( data[ field ] || '' )

    const onCustomChange = ( value: string ): void => {
        data[ field ] = value
        rowData[ idx ] = data

        setInput( value )
        setRowData( rowData )
        onChange && onChange( data )
    }
    return (
        <div className="data-grid-select-cell" style={ { width } }>
            <Select
                fullWidth
                value={ input }
                onChange={ ( e ) => onCustomChange( e?.target?.value ) }
            >
                {
                    dataSource.map( ( { value, name } ) =>
                        <MenuItem
                            key={ `${ value }${ name }` }
                            value={ value }
                        >
                            { name }
                        </MenuItem>
                    )
                }
            </Select>
        </div>
    )
}

export default DataGridSelectCell
